export default "__VITE_ASSET__dcfec411__"